import React, { useState, useRef, useEffect } from "react";
import { useLoading } from "../../../../Shared/cache/context/LoadingProvider";
import { useLanguage } from "../../../../Shared/cache/context/LanguageProvider";
import useFetch from "../../../../Shared/cache/useFetch";
import { TRANSLATION, GET, ORP_TRANSLATION, LANGUAGE_PREFIX } from "../../../../Shared/helper/constants";
import { resendOtpV1, verifyOtpAndAmUser, verifyOtpV1 } from "../../../orp/shared/service";
import ToastMsg from "../../../orp/shared/components/ToastMsg/ToastMsg";
import './AwOtpModal.scss'
import { eventEmitter, getEventName } from "../../../../Shared/service/google-analytics.service";
import { generateMsisdn } from "../../../../Shared/helper/helper";
import { AIRTEL_WORKS } from "../../constant/constant";
import { ORP } from "../../../orp/helper/constants";
import { safeJsonParse } from "../../../../Shared/utils/commonutils";

import '../../../orp/recharge/components/OtpModal/OtpModal.scss'

const AwOtpModal = ({ toggleModalEvent, refId, email, msisdn, isAirtelNumber, sendOtpVerifiedEvent, maxLimitExaustEvent, enablePin, inValidAmUserEvent, paymentMode }) => {
    const [formData, setFormData] = useState(new Array(6).fill(""));
    const inputRefs = useRef([]);
    const [timer, setTimer] = useState(60);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const [isValidOtp, setIsValidOtp] = useState(true);
    const [isOtpExpired, setIsOtpExpired] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(true);
    const { showLoader, hideLoader } = useLoading();
    const [toastMsg, setToastMsg] = useState(null);
    const [translation, setTranslation] = useState({
        otpVerification: "OTP verification",
        resend: "RESEND",
        areYouSure: "Are you sure?",
        balanceMsg: 'Your balance will be deducted by',
        from: "from",
        no: 'No',
        yes: 'Yes',
        otpNote: "OTP has been sent to",
        incorrectOtpText: "Please enter correct OTP",
        attemptExausted: "Maximum attempts exhausted.",
        attemptLeft: "ATTEMPTS LEFT"
    });
    const [otp, setOtp] = useState();
    const [noOfAttemptsLeft, setNoOfAttemptsLeft] = useState(5)
    const { languagePrefix, selectedLanguage } = useLanguage();
    const [txnInfo, setTxnInfo] = useState({});
    const { data: data, refetch } = useFetch({
        url: ORP_TRANSLATION.replace(LANGUAGE_PREFIX, languagePrefix),
        method: GET,
        key: TRANSLATION,
        cache: {
            enabled: true,
            ttl: 3600
        }
    });
    useEffect(() => {
        if (showOtpModal) {
            document.body.classList.add("modal-open");
        } else {
            document.body.classList.remove("modal-open");
        }
        return () => document.body.classList.remove("modal-open");
    }, [showOtpModal]);


    useEffect(() => {
        if (data?.payment?.awOtpModal) setTranslation(data?.payment?.awOtpModal)
    }, [data])

    useEffect(() => {
        const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
        if (!cachedData) {
            refetch(true);
        } else {
            refetch(false)
        }
    }, [selectedLanguage]);

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);

            return () => clearInterval(interval); // Cleanup interval on unmount
        } else {
            setIsResendDisabled(false); // Enable the resend button when timer reaches 0
        }
    }, [timer]);

    useEffect(() => {
        let txnInfo = sessionStorage.getItem("queryData");
        txnInfo = safeJsonParse(txnInfo);
        setTxnInfo({ ...txnInfo });

        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
        eventEmitter(AIRTEL_WORKS, 'hbb_otp_sent_form_loaded', 'page load', 'hbb_otp_sent_form_loaded', null);
    }, []);

    const showToastMsg = (type, message) => {
        setToastMsg({ type, message });
        setTimeout(() => setToastMsg(null), 10000);
    }

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60).toString().padStart(2, '0');
        const seconds = (time % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    };


    const handleResendOtp = () => {
        setIsOtpExpired(false);
        setNoOfAttemptsLeft(5);
        setIsValidOtp(true);
        showLoader();
        setFormData(new Array(6).fill(""))
        setTimer(60); // Reset timer back to 60 seconds
        setIsResendDisabled(true); // Disable resend button until timer is done
        // // this.loaderService.startLoading();
        let postRequestData = {
            refId: refId
        };
        let postRequest = {
            data: postRequestData,
        };
        resendOtpV1(postRequest).then(
            (res) => {
                hideLoader()
                // this.loaderService.stopLoading();
                let data;
                res = res?.data;
                if (
                    res &&
                    (res?.status == 200 || res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    refId = res?.result?.refId;
                    setIsOtpExpired(false);
                    setNoOfAttemptsLeft(5)
                    const eventName = txnInfo?.flow === ORP ? 'te_resend_otp_success' : 'hbb_otp_entered_resend';
                    eventEmitter(txnInfo?.flow || AIRTEL_WORKS, eventName, 'click', eventName, null);
                    return;
                } else {
                    if (res &&
                        (res?.status == 502 || res?.statusCode == 502)) {
                        // showToastMsg('Error', res.message || "Something Went Wrong!")
                        eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'te_resend_otp_failed', 'click', res?.message, null);
                        maxLimitExaustEvent(res.message);
                    }
                }
            },
            (error) => {
                hideLoader();
                showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
                eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'te_resend_otp_failed', 'click', error?.error?.message, null);
            }
        );
    };


    const handleChange = (element, index) => {
        const value = element.value;
        if (/^\d$/.test(value) || value === "") { // Allow only single digit numbers
            const newOtp = [...formData];
            newOtp[index] = value;
            setFormData(newOtp);
            // Move to the next input box
            if (value !== "" && index < 5) {
                inputRefs.current[index + 1].focus();
            }
            if (index === 5 && value) {
                generateEnteredOtp([...formData, value]);
                if (enablePin) {
                    verifyOtpAndUser([...formData, value])
                } else {

                    verifyOtp([...formData, value]);
                }

            }
        }
    };
    const verifyOtpAndUser = (otp) => {
        if (isOtpExpired) { return }
        let postRequestData = {
            refId: refId,
            otp: Object.values(otp).join(""),
            username: generateMsisdn(msisdn),
            paymentMode: paymentMode
        }
        let postRequest = {
            data: postRequestData,
        };
        showLoader();
        verifyOtpAndAmUser(postRequest).then(
            (res) => {
                let data;
                hideLoader()
                res = res?.data;
                if (
                    res &&
                    (res?.statusCode === 200 || res?.status?.toLowerCase() === "success")
                ) {
                    sendOtpVerifiedEvent(res?.result);
                    setShowOtpModal(false);
                    setIsValidOtp(true);
                    eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'te_verify_user_success', 'click', 'te_verify_user_success', null);
                } else if (res?.statusCode === 2003) {
                    setIsValidOtp(false);
                    if (noOfAttemptsLeft > 0) {
                        setNoOfAttemptsLeft((prev) => prev - 1)
                    }
                    eventEmitter(txnInfo?.flow || AIRTEL_WORKS, getEventName(txnInfo.rechargeType, 'paymentfail_am_invalid_otp'), 'click', getEventName(txnInfo.rechargeType, 'paymentfail_am_invalid_otp'), null)

                } else if (res?.statusCode === 2002) {
                    setIsOtpExpired(true);
                    setNoOfAttemptsLeft(0)
                } else if (res?.statusCode === 4001) {
                    setShowOtpModal(false);
                    setTimeout(() => toggleModalEvent(), 11000);
                    inValidAmUserEvent(res?.message);
                }
                else if (res?.statusCode === 400) {
                    showToastMsg("Error", res?.message || "Something Went Wrong!");
                    setShowOtpModal(false);
                    //change visibility of toggle globally instead of each component and then remove setTimeout of togglevent
                    setTimeout(() => toggleModalEvent(), 11000);
                }
                else {
                    setShowOtpModal(false);
                    showToastMsg("Error", "Something Went Wrong!")
                    //change visibility of toggle globally instead of each component and then remove setTimeout of togglevent
                    setTimeout(() => toggleModalEvent(), 11000);
                    eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'te_verify_user_failed', 'click', res?.message, null);

                }
            },
            (error) => {
                hideLoader();
                showToastMsg("Error", "Something Went Wrong!")
                setShowOtpModal(false);
                toggleModalEvent();
                eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'te_verify_user_failed', 'click', error?.message || error?.error?.message, null);

            }
        )
    }


    const generateEnteredOtp = (otp) => {
        setOtp(Object.values(otp).join(""));
    }

    const verifyOtp = (otp) => {
        let postRequestData = {
            refId: refId,
            otp: Object.values(otp).join(""),
        }
        let postRequest = {
            data: postRequestData,
        };
        showLoader();
        verifyOtpV1(postRequest).then(
            (res) => {
                let data;
                hideLoader()
                res = res?.data;
                if (
                    res &&
                    (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    sendOtpVerifiedEvent(res?.result?.uniqueCode);
                    setShowOtpModal(false);
                    setIsValidOtp(true);
                    eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'verify_otp_success', 'click', 'verify_otp_success', null);
                } else if (res?.statusCode == 2003) {
                    setIsValidOtp(false);
                    if (noOfAttemptsLeft > 0) {
                        setNoOfAttemptsLeft((prev) => prev - 1)
                    }
                    eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'hbb_otp_entered_incorrect', 'click', 'hbb_otp_entered_incorrect', null);

                } else if (res?.statusCode == 2002) {
                    setIsOtpExpired(true);
                    setNoOfAttemptsLeft(0)
                }
                else {
                    eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'te_verify_otp_failed', 'click', 'te_verify_otp_failed', null);
                }
            },
            (error) => {
                hideLoader();
                eventEmitter(txnInfo?.flow || AIRTEL_WORKS, 'verify_otp_failed', 'click', 'verify_otp_failed', null);
            }
        );
    }





    const handleBackspace = (e, index) => {
        if (e.key === "Backspace" && index > 0 && formData[index] === "") {
            inputRefs.current[index - 1].focus();
        }
    };



    return (<>
        {showOtpModal && <div id="myModal" className=" otp_verification-outer adv-modal modal fade in" role="dialog">
            <div className="otp-modal otp_verification_modal">
                {/* <!-- Modal content--> */}
                <div className="otp-content">
                    <div className="otp-header">
                        <a className="close" onClick={toggleModalEvent} >X</a>
                        <h3>{translation?.otpVerification}</h3>
                        <p>{translation.otpNote} {isAirtelNumber && <strong>{msisdn} {email ? 'and' : ''}</strong>}</p>
                        <p>  <strong> {email}</strong></p>
                    </div>
                    <div className="modal-body">
                        <div className="otp_bx_wrap">
                            {formData?.map((data, index) => (
                                <input
                                    className={`${(!isValidOtp && !isOtpExpired) ? 'otp-error' : ''}`}
                                    key={index}
                                    type="password"
                                    maxLength="1"
                                    autoComplete="off"
                                    value={formData[index]}
                                    onChange={(e) => handleChange(e.target, index)}
                                    onKeyDown={(e) => handleBackspace(e, index)}
                                    ref={(el) => (inputRefs.current[index] = el)}

                                />
                            ))}
                        </div>
                    </div>
                    <div className="otp-errorMsg">
                        {(!isValidOtp && !isOtpExpired) && <span onClick={handleResendOtp} disabled={isResendDisabled} >{translation.incorrectOtpText} </span>}
                        {isOtpExpired && <span >{translation.attemptExausted}</span>}

                        {(!isValidOtp && !isOtpExpired) && <span> {noOfAttemptsLeft} {translation.attemptLeft}</span>}

                    </div>
                    {/* add css disable calss using method isAccountLengthInValid */}
                    {!isOtpExpired && <div className="otp_bx_bottom">
                        <span className={`resend-button ${isResendDisabled ? 'disabled' : ''}`} onClick={handleResendOtp} disabled={isResendDisabled} >{translation?.resend}</span>
                        {isResendDisabled && <span>{formatTime(timer)}</span>}
                    </div>}

                </div>
            </div>
        </div>}
        {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={() => setToastMsg(null)}></ToastMsg>}
    </>)
}

export default AwOtpModal;